// FreeTimeRequest 하단 국가별 안내문 (Freetime Calculation / Precautions)
// - 표시 조건: ctrCd 일치 + (eiCatCd 미지정 = 수출/수입 공통) + (bkgPlcCd 미지정 = 전 지점)
// - 빈 문자열('')은 빈 줄(<br>) 하나를 의미
// - 원문 텍스트를 그대로 이전한 것이므로 오탈자를 포함해 임의 수정하지 않는다
export default [
  {
    ctrCd: 'KR',
    eiCatCd: 'O',
    calculation: [
      '수출(START DATE)',
      'DEM : 실제 컨테이너 반입일',
      'DET : 빈 컨테이너 반출일',
      'MOR : RF컨테이너 전원 공급일'
    ],
    precautions: [
      'OVER DAY 요율은 상단 "DEM/DET Tariff" 클릭 하시면 조회 가능합니다.',
      '최초 정산 이 후 Freetime 연장요청은 불가하오니 정산 전 연장요청 바랍니다.',
      '입금 후 정산건은 "입금/계산서 정보입력" 바랍니다.'
    ]
  },
  {
    ctrCd: 'KR',
    eiCatCd: 'I',
    calculation: [
      '수입(START DATE)',
      'OFC : 컨테이너 입항일',
      '(OFC= DEM+DET 통합적용)'
    ],
    precautions: [
      'OVER DAY 요율은 상단 "DEM/DET Tariff" 클릭 하시면 조회 가능합니다.',
      '최초 정산 이 후 Freetime 연장요청은 불가하오니 정산 전 연장요청 바랍니다.',
      '입금 후 정산건은 "입금/계산서 정보입력" 바랍니다.'
    ]
  },
  {
    ctrCd: 'JP',
    eiCatCd: 'O',
    calculation: [
      '1.Start Date',
      'DEMの場合 : 実入りコンテナの搬入日',
      'DETの場合  : 空コンテナの搬出日',
      '2. 計算方法',
      '港によりFreetime のカウント方法が異なるため、費用発生時には弊社より別途ご連絡致します。',
      '不明な点がありましたら弊社 Customer Service Teamまでお問い合わせください。'
    ],
    precautions: [
      '1. こちらは輸出のPOL側のFreetimeをご確認いただくページとなります。',
      '2. POD側のFreetimeにつきましては"Freetime Request Detail"ボタン(延長している場合)、または "DEM/DET Tariff" メニュー から日数をご確認下さい。'
    ]
  },
  {
    ctrCd: 'JP',
    eiCatCd: 'I',
    calculation: [
      '1. Start Date',
      'DEMの場合 : 本船の入港日',
      'DETの場合  : 実入りコンテナの搬出日',
      '2.  計算方法 : Start Dateからカウントします。 (* 土日祭日を含む）',
      '3.  OT/FRのOOG CargoはDirect Deliveryとなります。'
    ],
    precautions: [
      '1. DEMのStart Dateは本船の実際の入港日によって変動します。',
      'それにより、Gate-out Deadlineが変わる場合もございますので、ご注意ください。',
      '2. 請求書はPODの代理店にて発行しますので、発行のご依頼は代理店にお問い合わせください。',
      '* 連絡先 :  http://www.kmtcjapan.com/home/port_agent.asp'
    ]
  },
  {
    ctrCd: 'TH',
    eiCatCd: 'I',
    calculation: [
      'Freetime DEM/DET start date :',
      'DEM start actual berth date',
      'DET start gate out full date',
      '',
      '***LCH HZ move to HZ warehouse immediately after discharge***',
      '****DLY port LKB/SCT/BMT start gate in full at DLY port date****'
    ],
    precautions: [
      'DEM/DET combined cannot apply at TH side',
      '',
      '***LCH HZ cargo often occurs DET charge (is incorrect)',
      'because cargo movement shows gate out full from LCH to HZ warehouse',
      'but not show gate in full date at HZ warehouse***',
      '',
      '****BMT/SCT/BKK by BARGE did not show any detail on the website,',
      'Cnee should contact CS team to check free time****'
    ]
  },
  {
    ctrCd: 'VN',
    eiCatCd: 'O',
    calculation: [
      '1.Export',
      'Start: Pick up date',
      'End:ETD'
    ]
  },
  {
    ctrCd: 'VN',
    eiCatCd: 'I',
    calculation: [
      'Start Date',
      'DEM: actual berthing date',
      'DET: gate out date'
    ],
    precautions: [
      '1. Free time DET (Combined) is not applied in VN.',
      '2. Free time application after invoice issue is not applied.',
      '3. Storage Occurrence Sensing : STORAGE included in DEM, Direct calculation ICD, TCC.'
    ]
  },
  {
    ctrCd: 'MY',
    eiCatCd: 'I',
    calculation: [
      'DEM  : From actual container discharge until container gate out port',
      'DET : From container gate out port until empty return to depo'
    ],
    precautions: [
      'D&D in eKMTC is for reference only',
      'Actual amount need to check with our contractor agent (DND Control (M) Sdn Bhd)'
    ]
  },
  {
    ctrCd: 'PH',
    eiCatCd: 'O',
    calculation: [
      'DET Start Date - Actual GTO-OB-E',
      'DET End Date - Actual GTI-OB-F',
      'DEM Start Date - Actual GTI-OB-F',
      'DEM End Date - Actual LDG-OB-F'
    ],
    precautions: [
      '12% VAT is included in the Grand Total calculation for DEM/DET.'
    ]
  },
  {
    ctrCd: 'PH',
    eiCatCd: 'I',
    calculation: [
      "DEM Start Date - Actual Vesse's Berthing",
      'DEM End Date - Actual GTO-IB-F',
      'DET Start Date - Actual GTO-IB-F',
      'DET End Date - Actual GTI-IB-E'
    ],
    precautions: [
      '12% VAT is included in the Grand Total calculation for DEM/DET.'
    ]
  },
  {
    ctrCd: 'ID',
    eiCatCd: 'O',
    calculation: [
      'Export : DET (Combined)',
      'Start Date : Gate out Depot',
      'End Date : Load on Vessel',
      '',
      'Tariff : Available in link Local Brochure KMTC 2023',
      'Home -> Customer Service -> FAQ (JKT Inbound link guidance)'
    ],
    precautions: [
      'Pickup Empty container within normal freetime (7 Days)'
    ]
  },
  {
    ctrCd: 'ID',
    eiCatCd: 'I',
    calculation: [
      'Import : DET (Combined)',
      'Start Date : Actual Vessel Berthing',
      'End Date : Container returned at Depot KMTC',
      '',
      'Tariff : Available in link Local Brochure KMTC 2023',
      'Home -> Customer Service -> FAQ (JKT Inbound link guidance)'
    ],
    precautions: [
      'Empty return to Depot as per D/O validation date and deliver to KMTC Depot address as mentioned on D/O.'
    ]
  },
  {
    ctrCd: 'SG',
    eiCatCd: 'O',
    calculation: [
      'Export : DET (Combined) - 06 calendar days (for all types)',
      'Start Date : 6 days before vessel ETA SIN',
      '',
      'Depot PIC can access to ICC, depot will release container according to pick up date which is reflected under the ICC menu',
      '',
      'Depot KMTC operating hour (Mon – Fri 8am ~ 5pm, Sat 8am ~ 12pm, closed on Sun)'
    ]
  },
  {
    ctrCd: 'SG',
    eiCatCd: 'I',
    calculation: [
      'Import : DET (Combined) - 06 calendar days (for all types)',
      'Start Date : Vessel completion of discharge',
      '',
      '1) Consignee / clearing agent / haulier may call or email KMTC SG office for checking of free detention or detention charges may arise.',
      '2) Depot PIC can access to ICC, when haulier return container, actual detention charges will be informed for their direct settlement to depot.',
      '',
      'We start guide consignee / clearing agent / haulier to check free detention or detention charges thru KMTC website (https://www.ekmtc.com/index.html#/main)',
      '',
      'Depot KMTC operating hour (Mon – Fri 8am ~ 5pm, Sat 8am ~ 12pm, closed on Sun)'
    ]
  },
  {
    ctrCd: 'IN',
    eiCatCd: 'O',
    calculation: [
      'Detention',
      'Start Date - Empty gate-out depot',
      'End Date - (1) Laden gate-in at Terminal if POR is Port (2) Laden gate-in at ICD for POR-ICDs'
    ]
  },
  {
    ctrCd: 'IN',
    eiCatCd: 'I',
    calculation: [
      'DET (Combined)',
      'Start Date - (1) Actual Vessel Berthing if FPD is Port (2) Laden arrival at FPD if ICD',
      'End Date - Actual empty return to depot'
    ]
  },
  {
    ctrCd: 'HK',
    eiCatCd: 'O',
    calculation: [
      'DEM start date - Full container GTI date',
      'DET start date - Empty container GTO date'
    ]
  },
  {
    ctrCd: 'HK',
    eiCatCd: 'I',
    calculation: [
      'DEM start date : follow the start date in [Demurrage start correction]',
      'DET start date : full container GTO date.'
    ],
    precautions: [
      '1. Do not accept the freetime approval of DET(Combined) for HKG local cargo.',
      '2. The freetime of HZ and OOG is 72hrs and 24 hrs, the DEM invoice may not correct in e-KMTC, cnee should check with IMP team first.'
    ]
  },
  {
    ctrCd: 'CN',
    bkgPlcCd: 'NBO',
    eiCatCd: 'O',
    calculation: [
      'DET(conbined)',
      'Start date: Empty pick-up date',
      'End date: Estimated time of departure'
    ],
    precautions: [
      'Shipback cargo',
      'Start: Arrival date(imbound),End:Departure date(shipback)'
    ]
  },
  {
    ctrCd: 'CN',
    bkgPlcCd: 'XMN',
    eiCatCd: 'O',
    calculation: [
      'Dem (incl DET)',
      'Start:Emty pick up date',
      'End:departure date'
    ],
    precautions: [
      '1. Shipback cargo',
      'Start: Arrival date(imbound),End:Departure date(shipback)',
      '2. If you apply to get EIR in advance, you are responsible for dem(incl det)charge.',
      '3. Free time tariff of DG same as one of non DG.'
    ]
  },
  {
    ctrCd: 'CN',
    bkgPlcCd: 'XMN',
    eiCatCd: 'I',
    calculation: [
      'Dem (incl DET)',
      'Start:Arrival date',
      'End:Return to depot date'
    ],
    precautions: [
      'Free time tariff of DG same as one of non DG.'
    ]
  },
  {
    ctrCd: 'CN',
    bkgPlcCd: 'NKG',
    eiCatCd: 'O',
    calculation: [
      'Export (Combined)---Feeder',
      'Start:Empty pick up time---Movements updated manually',
      'End:Export full on board date---Automatically link leg vessel time',
      '(Declared shipment date, not actual shipment date)'
    ],
    precautions: [
      'Normal 7 days free time',
      'If need extend freetime,pls send request',
      'through EKMTC asap'
    ]
  },
  {
    ctrCd: 'CN',
    bkgPlcCd: 'NKG',
    eiCatCd: 'I',
    calculation: [
      'Import (Combined)---Feeder',
      'Start:IB Full discharge time(Actual DIS time)---Manually',
      'End:Empty return time---Manually'
    ],
    precautions: [
      'D&D in eKMTC is only for reference.',
      'Actuacl amount pls contact with local KMTC office.'
    ]
  },
  {
    ctrCd: 'US',
    precautions: [
      'Basic free days are based on working days; over days are charged on a calendar-day basis.'
    ]
  }
]
